import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const OpenDealsWithProperty = async (PropertyId) => {
  /**
   * input: PropertyId
   * output: Open Deals Array
   * description: Get Open Deals With A Specific Property
   */

  try {
    const DealsCollection = await collection(db, "deals");

    let q = query(
      DealsCollection,
      where("bid", "==", getLocalStorageItem("bid")),
      where("property", "==", PropertyId),
      where("currentstatus", "==", "open")
    );

    const DealsSnapshot = await getDocs(q);
    let Deals = [];
    DealsSnapshot.forEach((e) => Deals.push({ ...e.data(), id: e.id }));
    return Deals;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export default OpenDealsWithProperty;
